import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const NumberInput = ({
  input, label, meta: { error, touched }, disabled,
}) =>
  (<TextField
    {...input}
    floatingLabelText={label}
    errorText={touched && error}
    type="number"
    fullWidth
    disabled={disabled}
  />);

NumberInput.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/form/NumberInput.js